import { useMutation } from '@tanstack/react-query'
import { useState } from 'react'
import {
  checkServiceRequest,
  dealerEndClarificationService,
  deleteServiceRequestsFromReport,
  toClarifyServiceRequest,
} from '../../../services/NewApiService'
import {
  closeModalFn,
  openModalFn,
} from '../../../utils/controllers/ModalController'
import { MaintenanceOrder } from '../../ServiceReports/types/maintenance-reports.types'
import serviceReportDetailsDrawerStore from '../ServiceReportDetailsDrawer/stores/ServiceReportDetailsDrawerStore'
import { handleOnSuccess, onError } from './helpers'

export const useRequestReportActions = (
  request: MaintenanceOrder,
  updateOrders: any,
  getServiceComments: (id: number) => void,
) => {
  const { setOpenDrawer } = serviceReportDetailsDrawerStore
  const [comment, setComment] = useState('')
  const handleSetComment = (event: any) => setComment(event.target.value)

  const { mutateAsync: toClarifyServiceRequestFn } = useMutation({
    mutationKey: ['to-clarify-service-request'],
    mutationFn: () => toClarifyServiceRequest(request.id, { comment }),

    onSuccess() {
      const callback = () => {
        setComment('')
        getServiceComments(request.id)
      }
      handleOnSuccess({ withReportData: true }, callback)
    },
    onError,
  })

  const { mutateAsync: checkServiceRequestFn } = useMutation({
    mutationKey: ['check-service-request'],
    mutationFn: () => checkServiceRequest(request.id, request.reportId!),
    onSuccess() {
      handleOnSuccess({ withReportData: true })
    },
    onError,
  })

  const { mutateAsync: deleteRequestFn } = useMutation({
    mutationKey: ['delete-request-from-service-report'],
    mutationFn: () => {
      const body = {
        orderIds: [request.id],
      }
      return deleteServiceRequestsFromReport(request.reportId!, body)
    },
    onSuccess() {
      const callback = () => setOpenDrawer(false)
      const notification = `Заявка №${request.id} удалена из отчета  №${request.reportId}`
      handleOnSuccess(
        { withReportData: true, withReportTable: true, notification },
        callback,
      )
    },
    onError,
  })

  const { mutateAsync: dealerEndClarificationFn } = useMutation({
    mutationKey: ['dealer-end-clarification-service-report'],
    mutationFn: () => dealerEndClarificationService(request.id, { comment }),
    onSuccess(res) {
      getServiceComments(request.id)
      handleOnSuccess({
        withReportData: true,
        withReportTable: true,
        withCreateReportTable: true,
        withServiceTable: true,
      })
      updateOrders && updateOrders(res)
    },
    onError,
  })

  const handleClarifyServiceRequest = async () => {
    openModalFn['progress-backdrop']?.()
    await toClarifyServiceRequestFn()
    closeModalFn['progress-backdrop']?.()
  }

  const checkRequest = async () => {
    openModalFn['progress-backdrop']?.()
    await checkServiceRequestFn()
    closeModalFn['progress-backdrop']?.()
  }

  const dealerEndClarification = async () => {
    openModalFn['progress-backdrop']?.()
    await dealerEndClarificationFn()
    closeModalFn['progress-backdrop']?.()
  }

  const deleteRequest = () => {
    openModalFn['transaction-confirmation']?.({
      text1: `Подтвердить удаление заявки №${request.id} из отчета №${request.reportId}?`,
      processText: `Выполняется удаление заявки №${request.id} из отчета №${request.reportId}`,
      action: deleteRequestFn,
    })
  }

  return {
    deleteRequest,
    handleClarifyServiceRequest,
    checkRequest,
    dealerEndClarification,
    comment,
    handleSetComment,
  }
}
